import {Component, createEffect, createSignal} from "solid-js";
import {Server} from "../../logic/server";
import LoadingIcon from "./LoadingIcon";
import {useLocation} from "@solidjs/router";

type Props = {}

const Footer: Component<Props> = (props) => {
    const location = useLocation();
    const [serverVersion, setServerVersion] = createSignal<string | null>(null)
    const [isLoading, setIsLoading] = createSignal(false);

    const loadServerVersion = async () => {
        setIsLoading(true);
        try {
            const version = await Server.getVersion();
            setServerVersion(version);
        } catch (e) {
            throw e;
        } finally {
            setIsLoading(false);
        }
    };

    createEffect(() => {
        loadServerVersion();
    }, [])

    return <div id="footer">
        <div class="container">
            <p>S. Jansen © 2023 – 2026. All rights reserved.</p>
            {/* Don't show the versions if we are on the homepage ('' or '/') */}
            {location.pathname.length < 2 ? null : <>
                <div class={"versions"}>Version: {APP_VERSION} {APP_ENV == "production" ? "" : `(${APP_ENV})`}</div>
                <div class={"versions"}>Server: {isLoading() ? <LoadingIcon/> : serverVersion() ?? "unknown"}</div>
            </>}
        </div>
    </div>
}

export default Footer;